(() => {
  const bar = document.getElementById('SiennaStickyCart');
  const info = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
  if (!bar || !info) return;
  const action = bar.querySelector('[data-sticky-add]');
  const price = bar.querySelector('[data-sticky-price]');
  let pending = false;
  const original = () => info.querySelector('product-form button[name="add"]');
  const sync = () => {
    pending = false;
    const source = original();
    if (!source) { bar.hidden = true; return; }
    const rect = source.getBoundingClientRect();
    const cartOpen = document.querySelector('cart-drawer.active, cart-notification.active');
    const modalOpen = document.querySelector('product-modal[open], dialog[open]');
    const inView = rect.bottom > 0 && rect.top < window.innerHeight;
    bar.hidden = !!cartOpen || !!modalOpen || inView;
    const label = source.querySelector('span');
    const text = label ? label.textContent.trim() : source.textContent.trim();
    if (action.textContent.trim() !== text) action.textContent = text;
    action.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
    action.setAttribute('aria-busy', source.classList.contains('loading') ? 'true' : 'false');
    const container = info.querySelector('[id^="price-"] .price');
    const amount = container && container.querySelector(container.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
    if (amount && price.textContent.trim() !== amount.textContent.trim()) price.textContent = amount.textContent.trim();
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(sync); } };
  action.addEventListener('click', () => {
    const source = original();
    if (source && !source.disabled && source.getAttribute('aria-disabled') !== 'true') source.form.requestSubmit(source);
    schedule();
  });
  new MutationObserver(schedule).observe(info, { subtree: true, childList: true, attributes: true, characterData: true });
  for (const drawer of document.querySelectorAll('cart-drawer, cart-notification, product-modal')) {
    new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('change', schedule);
  sync();
})();
